import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = [ 'button', 'content' ]

  connect() {
    if (this.data.get('expand') === 'open') {
      this.open()
    } else {
      this.close()
    }
  }

  toggle() {
    if (this.data.get('expand') === 'open') {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.buttonTarget.querySelector('span').innerText = 'Close'
    this.buttonTarget.querySelector('i').innerText = 'expand_less'
    this.contentTarget.classList.remove('d-none')
    this.data.set('expand', 'open')
  }

  close() {
    this.buttonTarget.querySelector('span').innerText = 'Open'
    this.buttonTarget.querySelector('i').innerText = 'expand_more'
    this.contentTarget.classList.add('d-none')
    this.data.set('expand', 'close')
  }

  replace(event) {
    const response = event.detail[0]
    this.contentTarget.innerHTML = response

    Rails.fire(this.element, 'sectioncomplete')
  }
}
